import { useEffect, useState } from "react";
import client from "../lib/api";
import { money, fmtDate } from "../lib/helpers";
import { Receipt, Copy, Check } from "@phosphor-icons/react";
import { Badge } from "./ui/badge";
import { toast } from "sonner";

export default function PayoutHistory({ isAdmin, refreshKey }) {
  const [payouts, setPayouts] = useState(null);
  const [copied, setCopied] = useState("");

  useEffect(() => {
    client.get("/connect/payouts").then((r) => setPayouts(r.data.payouts || [])).catch(() => setPayouts([]));
  }, [refreshKey]);

  const copyId = (id) => {
    navigator.clipboard.writeText(id);
    setCopied(id); setTimeout(() => setCopied(""), 1600);
    toast.success("Transfer ID copied");
  };

  if (!payouts) return null;

  return (
    <div data-testid="payout-history">
      <div className="flex items-center gap-2 mb-3">
        <Receipt size={18} weight="duotone" className="text-[#4A0000]" />
        <h3 className="font-display text-lg">Payout history</h3>
      </div>
      <div className="border border-[#E9DDC6] rounded-md overflow-hidden bg-white">
        <table className="w-full text-sm" data-testid="payout-history-table">
          <thead>
            <tr className="bg-[#FAF9F6] text-left text-[#5C5A58]">
              <th className="p-4 font-medium">Date</th>
              <th className="p-4 font-medium">Property</th>
              {isAdmin && <th className="p-4 font-medium">Photographer</th>}
              <th className="p-4 font-medium">Amount</th>
              <th className="p-4 font-medium">Method</th>
              <th className="p-4 font-medium">Stripe transfer ID</th>
              <th className="p-4 font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {payouts.length === 0 && (
              <tr><td colSpan={isAdmin ? 7 : 6} className="p-8 text-center text-[#5C5A58]" data-testid="payout-history-empty">No payouts yet.</td></tr>
            )}
            {payouts.map((p, i) => (
              <tr key={p.transfer_id || i} className={i % 2 ? "bg-[#FBFAF7]" : "bg-white"} data-testid={`payout-history-row-${p.transfer_id}`}>
                <td className="p-4 whitespace-nowrap">{fmtDate(p.created_at)}</td>
                <td className="p-4 font-medium">{p.title || "—"}</td>
                {isAdmin && <td className="p-4">{p.payee_name || "—"}</td>}
                <td className="p-4 font-mono-num font-semibold text-[#2e7d32]">{money(p.amount)}</td>
                <td className="p-4">
                  {p.kind === "manual"
                    ? <Badge className="bg-[#FAF9F6] text-[#5C5A58] border-[#E9DDC6]">{p.method || "Offline"}</Badge>
                    : <Badge className="bg-[#635BFF]/10 text-[#4B45C6] border-[#635BFF]/20">Stripe</Badge>}
                </td>
                <td className="p-4">
                  {p.transfer_id ? (
                    <button onClick={() => copyId(p.transfer_id)} data-testid={`payout-copy-${p.transfer_id}`}
                      className="inline-flex items-center gap-1.5 font-mono-num text-xs text-[#5C5A58] hover:text-[#4A0000] transition-colors" title="Copy transfer ID">
                      <span className="truncate max-w-[160px]">{p.transfer_id}</span>
                      {copied === p.transfer_id ? <Check size={13} className="text-green-600" /> : <Copy size={13} />}
                    </button>
                  ) : <span className="text-[#9A968E]">—</span>}
                </td>
                <td className="p-4"><Badge className="bg-green-100 text-green-800 border-green-200 capitalize">{p.status || "paid"}</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
